module.exports = __webpack_public_path__ + "static/media/ritaDeLaFeria.5817b925.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/authorSpotlight/ritaDeLaFeria.jpg
// module id = 1691
// module chunks = 1